import produce from 'immer';
import create from 'zustand';

const useFeatureWireStore = create(set => ({
  showModal: false,
  featureable: {
    author: null,
    mentions: [],
  },
  selectedFeatureable: [],
  set: fn => set(produce(fn)),
}));

export default useFeatureWireStore;
